import { Heading } from '@chakra-ui/react';
import { FC, useContext } from 'react';
import EntityContext from '../../../context/EntityContext';
import { ParagraphActivityPoiNearPoisFragment } from '../../../generated/types';
import { useStore } from '../../../store/provider';
import getAppComponent from '../../../utils/getAppComponent';
import TeaserGrid from '../../Common/TeaserGrid';

interface ActivityPoiNearPoisProps {
  data: ParagraphActivityPoiNearPoisFragment;
}

export const ActivityPoiNearPois: FC<ActivityPoiNearPoisProps> = ({ data }) => {
  const entityContext = useContext(EntityContext);
  const store = useStore();

  if (!('nearPois' in entityContext.entity)) {
    return null;
  }

  const TeaserComponent = getAppComponent(
    process.env.APP_ID!,
    store.config.usesNewLayout,
    'PoiTeaser'
  );

  if (!entityContext.entity.nearPois.total) {
    return null;
  }

  return (
    <>
      {data.title && (
        <Heading mb={2} fontSize="2xl">
          {data.title}
        </Heading>
      )}
      <TeaserGrid columns={1} spacing={8}>
        {entityContext.entity.nearPois.items.map((poi) => {
          return (
            <TeaserComponent
              key={poi!.id}
              data={poi}
              imageContainerMaxWidth="320px"
              noOfLines={{
                base: 3,
                md: 3,
              }}
              hideCTA
            />
          );
        })}
      </TeaserGrid>
    </>
  );
};

export default ActivityPoiNearPois;
